export default ({ axios }) => ({
    /**
     * @description id is a branchGoodPropertyId
     * @param id
     * @param body
     * @returns Promise<Property, Error>
     */
    update: (id, body) => axios.patch(`/branch-good-properties/${id}`, body)
})



// WEBPACK FOOTER //
// ./src/api/branchGoodProperties.js